import { http } from '@/lib/http';
import type {
  ApprovePayload,
  AssignReviewerPayload,
  CancelRequest,
  ListCancelsQuery,
  RejectPayload,
} from '@/types/cancels';

const BASE = '/api/v1/cancels';

export interface CancelsPage {
  rows: CancelRequest[];
  total: number;
  page: number;
  pageSize: number;
}

export const cancelsService = {
  list: (q: ListCancelsQuery = {}) =>
    http.get<CancelsPage>(BASE, { params: q }),

  /** Cancel requests assigned to the current user in PENDING_REVIEW. */
  myReviews: () =>
    http.get<CancelRequest[]>(`${BASE}/my-reviews`),

  get: (id: string) =>
    http.get<CancelRequest>(`${BASE}/${id}`),

  assignReviewer: (id: string, payload: AssignReviewerPayload) =>
    http.post<CancelRequest>(`${BASE}/${id}/assign-reviewer`, payload),

  approve: (id: string, payload: ApprovePayload = {}) =>
    http.post<CancelRequest>(`${BASE}/${id}/review/approve`, payload),

  reject: (id: string, payload: RejectPayload) =>
    http.post<CancelRequest>(`${BASE}/${id}/review/reject`, payload),
};
